<script>
import { fb } from '@/lib/common'
export default {
  data: () => ({
    email: '',
    password: ''
  }),
  methods: {
    createUser () {
      fb.auth().createUserWithEmailAndPassword(this.email, this.password)
        .then(() => {
          alert(`${this.email}を登録しました。`)
          this.email = ''
          this.password = ''
        })
        .catch(error => {
          alert(error)
          console.error(error)
        })
    }
  }
}
</script>

<template>
  <div class="user-reg">
    <input
      type="email"
      placeholder="Mail Address"
      v-model="email"
    >
    <input
      type="password"
      placeholder="Password"
      v-model="password"
    >
    <input
      type=submit
      value="Create a new account"
      @click="createUser"
    >
  </div>
</template>

<style lang="scss" scoped>
</style>
